import axios from 'axios'

export const getDownloads = ({ commit }) => {
  commit('setLoading', true);
  return axios.post('/api/downloads/list')
    .then(response => {
      commit('getDownloads', response.data.data);
    })
    // fail
    .catch(e => {
      commit('getDownloads', e.response)
    })
    .finally(() => {
      commit('setLoading', false);
    });
}

export const emitSuccessAlert = ({ commit }) => {
  setTimeout(() => {
    commit('success/pushSuccess', 'Su descarga está lista', { root: true });
  }, 1000)

};

export const resolvePendingExport = ({ commit, dispatch, state }, { key }) => {
  return dispatch('getDownloads').then(() => {
    if (!Array.isArray(state.downloads)) {
      commit('failPendingExport', { key, message: 'No se pudo confirmar el archivo generado.' });
      return;
    }
    const latest = state.downloads.reduce((max, item) => (
      (!max || item.id > max.id) ? item : max
    ), null);
    commit('resolvePendingExport', { key, downloadRow: latest });
  });
}
